import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { type ContactTypeFlags, contactTypes } from '../contactTypes'
import { contactTypeIcons } from './ContactTypeIcons.css'

type Props = {
  contact: Partial<ContactTypeFlags>
}

export const ContactTypeIcons = ({ contact }: Props) => {
  const heldTypes = contactTypes.filter(({ key }) => contact[key] === true)

  if (heldTypes.length === 0) {
    return null
  }

  return (
    <span className={contactTypeIcons}>
      {heldTypes.map(({ key, label, icon }) => (
        <Tooltip key={key} text={label} direction="top" asChild>
          <FontAwesomeIcon icon={icon} aria-label={label} />
        </Tooltip>
      ))}
    </span>
  )
}
